// export const BASEURL = 'http://gogo-cinemacon.binarynumbers.io';
// export const BASEURL = 'http://gogocinema.binarynumbers.io';
// export const BASEURL = 'https://api.gogocinema.com';
// export const BASEURL = 'http://developmentgogocinema.binarynumbers.io';
// export const BASEURL = 'http://www.yogesh.com';
// export const BASEURL = 'https://api-uat.gogocinema.com';
// export const BASEURL = 'https://gogo-alpha-api.binarynumbers.io';
// export const BASEURL = 'http://13.228.128.234';
// export const BASEURL = 'http://api.gogocinema.com';

var url = "";
if (window.location.host === "qr-code-app.epixcinemas.com") {
  url = "https://api.epixcinemas.com";
} else {
  // url = 'http://localhost:3800'
  url = "https://api.epixcinemas.com";
}
export const URL_BASE = url;



// WEBPACK FOOTER //
// ./src/helper/constants.js